const PaymentGatewayDashboardOptions = () => {
  return (
    <>
      <div className="ail-info-card-area pt-100 pb-80">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-xl-7 col-lg-9">
              <div className="text-center mb-30">
                <h2 className="ail-title text-black fs-48 fw-600">
                  <span className="ail-highlighted-text">
                    Payment solution
                  </span>{" "}
                  for every industry
                </h2>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-xxl-4 col-lg-6">
              <div className="white-50-bg p-4 pt-40 rounded-16 d-flex gap-3 flex-wrap mt-20">
                <div className="ail-card-content">
                  <h4 className="text-black fs-20">eCommerce</h4>
                  <p className="text-black">
                    Get instant access to borrowers spending habits, income and expenses analysis, balance check and more.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-xxl-4 col-lg-6">
              <div className="white-50-bg p-4 pt-40 rounded-16 d-flex gap-3 flex-wrap mt-20">
                <div className="ail-card-content">
                  <h4 className="text-black fs-20">Retail</h4>
                  <p className="text-black">
                    Boost conversions and reduce fraud. Receive payments in two clicks. Players get their winnings in seconds.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-xxl-4 col-lg-6">
              <div className="white-50-bg p-4 pt-40 rounded-16 d-flex gap-3 flex-wrap mt-20">
                <div className="ail-card-content">
                  <h4 className="text-black fs-20">Digital Goods</h4>
                  <p className="text-black">
                    Get more deposits and eliminate chargebacks. Account is loaded with FIAT in two clicks. Users get their funds in seconds.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-xxl-4 col-lg-6">
              <div className="white-50-bg p-4 pt-40 rounded-16 d-flex gap-3 flex-wrap mt-20">
                <div className="ail-card-content">
                  <h4 className="text-black fs-20">Financial Services</h4>
                  <p className="text-black">
                    Make your customers more wealthy with Sunlex to receive payments. Receive payments in two clicks.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-xxl-4 col-lg-6">
              <div className="white-50-bg p-4 pt-40 rounded-16 d-flex gap-3 flex-wrap mt-20">
                <div className="ail-card-content">
                  <h4 className="text-black fs-20">Gaming</h4>
                  <p className="text-black">
                    Add open banking to your stack. Provide your customers the power to receive payments in two clicks and make payouts in seconds
                  </p>
                </div>
              </div>
            </div>
            <div className="col-xxl-4 col-lg-6">
              <div className="white-50-bg p-4 pt-40 rounded-16 d-flex gap-3 flex-wrap mt-20">
                <div className="ail-card-content">
                  <h4 className="text-black fs-20">Crypto</h4>
                  <p className="text-black">
                    Give your users the payment experience they deserve with paying just with biometrics. No chargebacks with open banking.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PaymentGatewayDashboardOptions;
